export default "__VITE_ASSET__B7Uc_F5l__"